import { useEffect } from "react";
import { toast } from "sonner";
import { applyLanguage, detectSupportedLang, readLangCookie, LANG_PROMPT } from "@/lib/translate";

// Loads the Google Website Translate widget ONCE (hidden). Custom language
// pickers elsewhere drive it via the hidden .goog-te-combo, so it works on
// desktop and mobile without duplicate-id conflicts.
export const GoogleTranslateHost = () => {
  useEffect(() => {
    if (window.__ghTranslateLoaded) return;
    window.__ghTranslateLoaded = true;
    window.googleTranslateElementInit = () => {
      /* global google */
      new window.google.translate.TranslateElement(
        { pageLanguage: "en", includedLanguages: "en,es,id,zh-TW", autoDisplay: false },
        "google_translate_element"
      );
    };
    const s = document.createElement("script");
    s.src = "//translate.google.com/translate_a/element.js?cb=googleTranslateElementInit";
    s.async = true;
    document.body.appendChild(s);
  }, []);

  // First-visit prompt for visitors whose browser is set to a supported language.
  useEffect(() => {
    let dismissed = false;
    try { dismissed = localStorage.getItem("hf_lang_prompt") === "1"; } catch { /* ignore */ }
    if (dismissed) return;
    if (readLangCookie() !== "en") return; // already viewing translated
    const code = detectSupportedLang();
    if (!code || !LANG_PROMPT[code]) return;
    const mark = () => { try { localStorage.setItem("hf_lang_prompt", "1"); } catch { /* ignore */ } };
    const t = setTimeout(() => {
      const { msg, action } = LANG_PROMPT[code];
      toast(msg, {
        duration: 12000,
        action: { label: action, onClick: () => { mark(); applyLanguage(code); } },
        onDismiss: mark,
        onAutoClose: mark,
      });
    }, 1800);
    return () => clearTimeout(t);
  }, []);

  return <div id="google_translate_element" aria-hidden="true" className="gh-gt-host notranslate" translate="no" />;
};
